<template>
  <div class="page__sidebar h-100">
    <component
      :is="sideBar"
      :not-read="notRead"
      :drafts="drafts"
      :issues="issues"
      :counters="allCounters"
      :options="options"
      :selected-option="selectedOption"
      :store="store"
      :disable-add-filter="disableAddFilter"
      :custom-options="customOptions"
      :is-incidents="true"
      @expand="expand"
      @setDefaultOptionParent="setDefaultOption($event)"
      @contract="contract"
      @update:selected-option="changeSelectedOption"
      @click-add-filter="$emit('click-add-filter')"
      @remove-option="removeCustomOption"
      @rename-option="showRenameModal"
      @update-option="showUpdateModal"
    />
    <modal-confirmation
      id="incidentsSideBarConfirmationModal"
      ref="confirmationModal"
    />
    <rename-custom-filter-modal
      id="renameCustomFilterModal"
      ref="renameModal"
      @ok="renameCustomOption"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import store from './incidentSideBarStore'
import ModalConfirmation from '@/components/modals/ModalConfirmation'
import RenameCustomFilterModal from '@/components/customFilter/RenameCustomFilterModal'

export default {
    name: 'IncidentsSideBar',
    components: {
        ModalConfirmation,
        RenameCustomFilterModal
    },
    props: {
        counters: { type: Object } // a map containing the numbers for each badge
    },
    data() {
        return {
            store: store,
            state: store.state
        }
    },
    computed: {
        sideBar() {
            return this.state.sideBar
        },
        customOptions() {
            return this.state.customOptions
        },
        options() {
            return this.state.options
        },
        selectedOption() {
            return this.state.selectedOption
        },
        disableAddFilter() {
            return this.gridRouteName !== this.$route.name
        },
        gridRouteName() {
            return this.state.gridRouteName
        },
        notRead() {
            return this.counters && this.counters.requestsWithReportNotReaded
        },
        drafts() {
            return this.counters && this.counters.draftRequests
        },
        issues() {
            return this.counters && this.counters.requestsWithIssue
        },
        allCounters() {
            return this.counters
        }
    },
    methods: {
        changeSelectedOption(value) {
            store.setSelectedOption(value)
            this.$router.push({ name: this.gridRouteName })
            this.$emit('changed-option', value)
        },
        selectDefaultOption() {
            store.selectDefaultOption()
            this.$emit('changed-option', this.state.selectedOption)
        },
        removeCustomOption(option) {
            this.$refs.confirmationModal.ask(() => {
                store.removeCustomOption(option)
                this.showToastSuccessGlobal(this.$t('global.filterDeleted'))
            })
        },
        showRenameModal(option) {
            this.$refs.renameModal.show(option)
        },
        renameCustomOption(option) {
            store.renameCustomOption(option)
            this.showToastSuccessGlobal(this.$t('global.renamedFilter'))
        },
        showUpdateModal(option) {
            this.$refs.confirmationModal.ask(() => {
                this.$emit('update-option', option)
            })
        },
        expand() {
            store.expandSideBar()
            Vue.nextTick(() => { this.$emit('changed-width') })
        },
        contract() {
            store.contractSideBar()
            Vue.nextTick(() => { this.$emit('changed-width') })
        },
        setDefaultOption(ev) {
            store.setDefaultOption(ev)
            store.saveConfig()
        }
    }
}

</script>
